import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';
import { fetchPieChartData, PieChartResponse } from '../../api/piechart';

// Async thunk for fetching pie chart data
export const fetchPieChartAsync = createAsyncThunk(
  'pieChart/fetchPieChart',
  async (_, { rejectWithValue }) => {
    try {
      const response = await fetchPieChartData();
      return response;
    } catch (error: any) {
      return rejectWithValue(error.message || 'Failed to fetch pie chart data');
    }
  }
);

// Pie chart state interface
export interface PieChartState {
  chartData: PieChartResponse | null;
  loading: boolean;
  error: string | null;
  message: string | null;
}

// Initial state
const initialState: PieChartState = {
  chartData: null,
  loading: false,
  error: null,
  message: null,
};

// Pie chart slice
const pieChartSlice = createSlice({
  name: 'pieChart',
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
    clearMessage: (state) => {
      state.message = null;
    },
    clearChartData: (state) => {
      state.chartData = null;
      state.error = null;
      state.message = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Fetch pie chart data
      .addCase(fetchPieChartAsync.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.message = null;
      })
      .addCase(fetchPieChartAsync.fulfilled, (state, action: PayloadAction<PieChartResponse>) => {
        state.loading = false;
        state.chartData = action.payload;
        state.message = action.payload.message;
        state.error = null;
      })
      .addCase(fetchPieChartAsync.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
        state.chartData = null;
        state.message = null;
      });
  },
});

// Export actions
export const { clearError, clearMessage, clearChartData } = pieChartSlice.actions;

// Export reducer
export default pieChartSlice.reducer;